skrilla.controller('createContestMarketsModalCtrl', async function ($scope, searchService, cacheService, srefService, modalService, queryService, paginationService, sportService) {

  $scope.selectedContests = cacheService.getObject("selectedPickemsContests");
  $scope.contestIds = $scope.selectedContests.map(it => it.id);
  $scope.contestTitles = {}
  $scope.moreMarketsExpected = false
  $scope.selectedContests.forEach(it => $scope.contestTitles[it.id] = it.title)

  const getEvents = function () {
    cacheService.registerObject($scope.queryKey, $scope.query);
    return searchService.get("pickems/events" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
      $scope.pickemsEvents = response.data.result;
      cacheService.registerObject($scope.key, $scope.pickemsEvents);
      paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
      // getMarkets(response.data.result)
      $scope.pickemsEvents.forEach(e => {
        Object.keys(e.contests || []).forEach(contestId => {
          if ($scope.contestTitles[contestId]) {
            e.usedBy = true
          }
        })
      })
    });
  };

  $scope.sports = await sportService.getSports();
  $scope.key = "pickemsEvents";
  $scope.pageKey = "pickemsEventsPage";
  $scope.queryKey = "queryPickemsEvents";
  $scope.selectedEvents = [];


  $scope.reset = function () {
    const endTime = new Date();
    endTime.setDate(endTime.getDate() + 7);
    $scope.query = {
      eventTypes: 'MATCH',
      startTime: new Date(),
      endTime: endTime,
      sortBy: "scheduled_start_time",
      sortOrder: "ASC"
    };
  };
  $scope.reset()

  $scope.resetLoad = function () {
    const endTime = new Date();
    endTime.setDate(endTime.getDate() + 3);
    $scope.load = {
      sport: $scope.sports[0],
      endTime: endTime
    };
  };

  $scope.toggleLoadCard = function () {
    $scope.loadEvents = !$scope.loadEvents
    if ($scope.loadEvents) {
      $scope.resetLoad()
    }
  };

  const getIds = function (list) {
    return list.map(function (el) {
      return el.id;
    });
  };

  $scope.create = function () {
    modalService.confirm("Are you sure you'd like to add these markets?", function () {
      searchService.post("pickems/contests/markets", {
          moreMarketsExpected: $scope.moreMarketsExpected,
          contestIds: getIds($scope.selectedContests),
          eventIds: getIds($scope.selectedEvents)
      },"Markets Successfully Add!")
    });
  };
  $scope.search = function () {
    paginationService.resetPage($scope.pageKey);
    paginationService.pageQuery(getEvents, $scope.pageKey);
  };


  $scope.load = function () {
    return searchService.post("betting/events/load", $scope.load, "Betting Events Loading...").then(function (response) {

    });
  };

  $scope.clicked = function(bettingEvent){
    if(bettingEvent.selected === false || bettingEvent.selected === undefined) {
      $scope.selectedEvents.push(bettingEvent);
    }
    else{
      $scope.selectedEvents = $scope.selectedEvents.filter(function(_bettingEvent){return _bettingEvent.id !== bettingEvent.id});
    }
  };

  $scope.close = function () {
    modalService.dismissAll();
  }

});
